module.exports = __webpack_public_path__ + "static/the-orphan-masters-son-6061db97eb15cbd8266d01a69ee3525b.jpg";